import AcceptanceRuleService from "@/services/insurancepricing/AcceptanceRuleService";
import AcceptanceRuleDescriptionService from "@/services/insurancepricing/AcceptanceRuleDescriptionService";

const acceptanceRuleService = new AcceptanceRuleService();
const acceptanceRuleDescriptionService = new AcceptanceRuleDescriptionService();

const state = {
    acceptanceRules: [],
    acceptanceRuleDescriptions: [],
    acceptanceRule: {},
    acceptanceRuleRevision: null,
    processed: false
};

const getters = {
    getAcceptanceRules(state) {
        return state.acceptanceRules;
    },
    getAcceptanceRuleDescriptions(state) {
      return state.acceptanceRuleDescriptions;
    },
    acceptanceRuleProcessed(state) {
        return state.processed;
    },
    getAcceptanceRule(state) {
      return state.acceptanceRule;
    },
    acceptanceRuleRevision(state) {
      return state.acceptanceRuleRevision
    }
};

const actions = {
    fetchAcceptanceRules({commit}, params) {
        return new Promise((resolve, reject) => {
            acceptanceRuleService.findAllByParams(
                params
            )
                .then(response => {
                    commit("SET_ACCEPTANCERULES", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    createAcceptanceRuleDescription({commit}, {id, acceptanceRuleDescription}) {
      return new Promise((resolve, reject) => {
        acceptanceRuleDescriptionService.save(id, acceptanceRuleDescription)
          .then(response => {
            commit("CREATED_ACCEPTANCE_RULE_DESCRIPTION", response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAcceptanceRuleDescriptions({commit}, id) {
      return new Promise((resolve, reject) => {
        acceptanceRuleDescriptionService.findAll(id)
          .then(response => {
            commit("SET_ACCEPTANCE_RULE_DESCRIPTIONS", response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    fetchAcceptanceRule({commit}, id) {
        return new Promise((resolve, reject) => {
            acceptanceRuleService.get(
                id
            )
                .then(response => {
                    commit("SET_ACCEPTANCERULE", response.data);
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    fetchAcceptanceRuleRevision({commit}, id) {
      return new Promise((resolve, reject) => {
        acceptanceRuleService.getRevision(
          id
        )
          .then(response => {
            commit("SET_ACCEPTANCERULE_REVISION", response.data);
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createAcceptanceRule({commit}, acceptanceRule) {
        return new Promise((resolve, reject) => {
            acceptanceRuleService.save(acceptanceRule)
                .then(response => {
                    commit("CREATED_ACCEPTANCERULE");
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updateAcceptanceRule({commit}, {id, acceptanceRule}) {
        return new Promise((resolve, reject) => {
            acceptanceRuleService.update(id, acceptanceRule)
                .then(response => {
                    commit("UPDATED_ACCEPTANCERULE");
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    deleteAcceptanceRule({commit}, id) {
        return new Promise((resolve, reject) => {
            acceptanceRuleService.delete(id)
                .then(response => {
                    commit("DELETED_ACCEPTANCERULE");
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};

const mutations = {
    SET_ACCEPTANCE_RULE_DESCRIPTIONS(state, data) {
      state.acceptanceRuleDescriptions = data;
      state.processed = false;
    },
    CREATED_ACCEPTANCE_RULE_DESCRIPTION(state, data) {
      state.acceptanceRuleDescriptions.push(data);
      state.processed = false;
    },
    SET_ACCEPTANCERULES(state, data) {
        state.acceptanceRules = data;
        state.processed = false;
    },
    SET_ACCEPTANCERULE(state, data) {
        state.acceptanceRule = data;
        state.processed = false;
    },
    SET_ACCEPTANCERULE_REVISION(state, data) {
      state.acceptanceRuleRevision = data;
      state.processed = false;
    },
    CREATED_ACCEPTANCERULE(state) {
        state.processed = true;
    },
    UPDATED_ACCEPTANCERULE(state) {
        state.processed = true;
    },
    DELETED_ACCEPTANCERULE(state) {
        state.processed = true;
    },
    CLEAR_ACCEPTANCERULE_DESCRIPTIONS(state) {
      state.acceptanceRuleDescriptions = [];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
